import { render, staticRenderFns } from "./FeedbackComponent.vue?vue&type=template&id=8d161d8c&scoped=true"
import script from "./FeedbackComponent.vue?vue&type=script&lang=js"
export * from "./FeedbackComponent.vue?vue&type=script&lang=js"
import style0 from "./FeedbackComponent.vue?vue&type=style&index=0&id=8d161d8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d161d8c",
  null
  
)

export default component.exports